<template>
  <v-form v-model="ui.valid" ref="form">
    <v-container grid-list-md>
      <v-layout row wrap v-if="!ui.isBusy">
        <v-flex xs12 md4 order-xs1 order-lg2>
          <v-toolbar color="pink" dark>
            <v-icon>camera_alt</v-icon>
            <v-toolbar-title>Player Image</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card>
            <v-card-text>
              <drop-zone
                :url="uploadUrl"
                max-files="1"
                max-size="2"
                :file-slot="player.avatar.slot"
                @success="slotUpdate"
                accept-types="image/*"
                :existing-files="ui.previews"
                :msg="ui.uploadMsg"></drop-zone>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 md8 order-xs2 order-lg1>
          <v-toolbar color="pink" dark>
            <v-icon>account_circle</v-icon>
            <v-toolbar-title>Player Profile</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field v-model="player.name" :rules="ui.required" label="Full Name"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-combobox v-model="player.gender" :items="['Female','Male']" label="Gender"></v-combobox>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="player.guardian"
                    :rules="ui.required"
                    label="Father's Name"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-dialog
                    ref="dialog"
                    v-model="ui.dobOpen"
                    :return-value.sync="player.dateOfBirth"
                    persistent
                    lazy
                    full-width
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="formattedDate"
                        label="Date of Birth"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="player.dateOfBirth" scrollable :max="ui.maxDob">
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="ui.dobOpen = false">Cancel</v-btn>
                      <v-btn flat color="primary" @click="$refs.dialog.save(player.dateOfBirth)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="player.aadharNumber"
                    :rules="ui.required"
                    label="Aadhar Number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="player.phoneNumber"
                    :rules="ui.required"
                    label="Phone Number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-model="player.identification1" label="Identification Mark 1"></v-text-field>
                </v-flex>

                <v-flex xs6>
                  <v-text-field v-model="player.identification2" label="Identification Mark 2"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="player.address" :rules="ui.required" label="Address" />
                </v-flex>
                <v-flex xs12>
                  <v-combobox
                    v-model="player.district"
                    :items="ui.districts"
                    label="District Of Residence"
                  ></v-combobox>
                </v-flex>

                <v-flex xs12>
                  <v-radio-group v-model="player.occupationType" row>
                    <v-radio label="Student" value="Student"></v-radio>
                    <v-radio label="Employed" value="Employed"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="player.institution"
                    :rules="ui.required"
                    label="Institution's Name"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="player.institutionAddress"
                    :rules="ui.required"
                    label="Institution's Address"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-btn color="red lighten-1" dark :to="{name:'player-list'}">Cancel</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="register" :loading="ui.isSaving">Update Details</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>

        <v-snackbar   auto-height   v-model="ui.snackbar" :color="ui.snackbarMode" :timeout="5000">
          <span>{{ ui.feedback }}</span>
          <v-btn dark flat @click="ui.snackbar = false">Close</v-btn>
        </v-snackbar>
      </v-layout>
      <v-layout v-if="ui.isBusy">
         <v-card>
           <v-flex xs12>
                <div class="text-xs-center" v-if="!player.avatar.slot">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </div>
              </v-flex>
         </v-card>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import moment from "moment";
import DropZone from "./DropZone";
import _ from "underscore";
import { mapState } from "vuex";

export default {
  data: function() {
    return {
      player: {
        name: "",
        dateOfBirth: moment()
          .subtract(15, "years")
          .toISOString()
          .substr(0, 10), //.format("DD-MMM-YYYY"),
        guardian: "",
        address: "",
        gender: "",
        identification1: "",
        identification2: "",
        aadharNumber: "",
        phoneNumber: "",
        district: "",
        occupationType: "",
        institution: "",
        institutionAddress: "",
        avatar: {
          slot: "",
          uploaded: false
        }
      },
      ui: {
        maxDob: moment()
          .subtract(5, "years")
          .toISOString()
          .substr(0, 10),
        valid: null,
        dobOpen: false,
        required: [
          function(x) {
            return x ? true : "This field is required";
          }
        ],
        districts: [
          "Alappuzha",
          "Ernakulam",
          "Idukki",
          "Kannur",
          "Kasargod",
          "Kollam",
          "Kottayam",
          "Kozhikode",
          "Malappuram",
          "Palakkad",
          "Pathanamthitta",
          "Thiruvananthapuram",
          "Thrissur",
          "Wayanad"
        ],
        snackbar: false,
        feedback: "",
        snackbarMode: "success",
        stage: 1,
        isSaving:false,
        isBusy:false,
        previews: [],
        uploadMsg:"Click here to upload image. Image should be minimum 300x400 (width x height) and under 2Mb. Images are replaced immediately upon upload"
      }
    };
  },
  computed: {
    ...mapState("config", ["identity", "meta"]),
    formattedDate: function() {
      return this.player.dateOfBirth
        ? moment(this.player.dateOfBirth).format("DD-MMM-YYYY")
        : "";
    },
    uploadUrl: function() {
      return this.$api("upload/player").url;
    }
  },
  methods: {
    slotUpdate: function() {
      this.player.avatar.uploaded = true;
    },
    createSlot: function() {
      var me = this;
      this.$api("upload")
        .post({})
        .then(function(resp) {
          me.player.avatar.slot = resp.slot;
        });
    },
    register: function() {
      if (!this.$refs.form.validate()) return;

      var me = this;
      me.ui.isSaving=true;
      var player = _.omit(this.player, "avatar");
      player.avatar = this.player.avatar.slot;
      this.$api("players")
        .put(player)
        .then(function() {
          me.showsnackBar("Saved Successfully", "success");
          me.$router.push({name:"player-list"});
        })
        .catch(function(ex) {
          var msg =
            ex && ex.responseJSON
              ? ex.responseJSON.feedback || ex.responseJSON.title
              : "An error occured!";
          me.showsnackBar(msg, "error");
        }).finally(function(){
          me.ui.isSaving=false;
        });
    },
    openPlayerForm: function(id) {
      var url =
        this.meta.apiUrl +
        "/reports/playerbio/" +
        id +
        "?key=" +
        this.identity.token;
      window.open(url);
    },
    showsnackBar: function(msg, mode) {
      this.ui.feedback = msg;
      this.ui.snackbar = true;
      this.ui.snackbarMode = mode || "info";
    },
    clearSlot: function() {}
  },
  mounted: function() {
    var id = this.$route.params.id;
    if (!id) return;

    var me = this;
    me.ui.isBusy=true;
    this.$api("players")
      .get({ id: id })
      .then(function(resp) {
        var player = _.extend({}, me.player);
        _.extend(player, resp);
        player.dateOfBirth=player.dateOfBirth.substr(0, 10);
        me.player = player;
        me.player.avatar.slot = me.player.id;
        me.ui.previews = [
          {
            processing: true,
            accepted: true,
            name: resp.name,
            size: 0,
            type: "image/jpeg",
            status: window.Dropzone.SUCCESS,
            thumbnail: me.meta.baseUrl + "/serve/profileimage/" + id + ".jpg"
          }
        ];
      })
      .catch(function() {}).finally(function(){
        me.ui.isBusy=false;
      });
  },
  components: {
    DropZone
  }
};
</script>

<style>
</style>
